<template>
  <div class="machine-slideshow">
    <Card
      v-for="(machine, index) in machines"
      :key="index"
      :index="index"
      :machine="machine"></Card>
  </div>
</template>

<script type="text/babel">
import Card from '../Machines/Card.vue';

export default {
  name: 'Machines',
  props: {
    value: {
      required: true,
    },
    max: {
      default: 5,
      type: Number,
    },
  },
  components: {
    Card,
  },
  data() {
    return {};
  },
  computed: {
    machines() {
      return this.$store.getters.getMachines.slice(0, this.max);
    },
  },
};
</script>

<style lang="scss">
  .machine-slideshow {
    padding: 1em;
    overflow: auto;
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1em;
    height: 100%;
    .machine {
      &__image {
        flex: 0 1 auto;
        overflow: hidden;
      }
      .readmore {
        display: none;
      }
    }
  }
</style>
